(function () {
  if (window.promotionBlockPinsLoaded) return;
  window.promotionBlockPinsLoaded = true;

  var openDialog = null;

  function readConfig(dialog) {
    var node = dialog.querySelector("[data-pin-config]");
    if (!node) return { variants: [], labels: {} };
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return { variants: [], labels: {} };
    }
  }

  function selectedOptions(form) {
    return Array.prototype.map.call(form.querySelectorAll("[data-pin-option]"), function (group) {
      var checked = group.querySelector("input:checked");
      return checked ? checked.value : null;
    });
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return options.every(function (value, index) {
        return value === variant.options[index];
      });
    });
  }

  function markUnavailableValues(form, variants, options) {
    form.querySelectorAll("[data-pin-option]").forEach(function (group, groupIndex) {
      group.querySelectorAll("input[type='radio']").forEach(function (input) {
        var candidate = options.slice();
        candidate[groupIndex] = input.value;
        var match = findVariant(variants, candidate);
        var label = form.querySelector("label[for='" + input.id + "']");
        if (label) label.classList.toggle("is-unavailable", !match || !match.available);
      });
    });
  }

  function syncVariant(dialog, config) {
    var form = dialog.querySelector("form");
    if (!form) return;

    var options = selectedOptions(form);
    var variant = options.length ? findVariant(config.variants, options) : config.variants[0];
    var idInput = form.querySelector("[data-pin-variant-id]");
    var submit = form.querySelector("[data-pin-submit]");
    var price = dialog.querySelector("[data-pin-price]");
    var comparePrice = dialog.querySelector("[data-pin-compare-price]");
    var details = dialog.querySelector("[data-pin-details]");

    markUnavailableValues(form, config.variants, options);

    if (idInput) idInput.value = variant && variant.available ? variant.id : "";

    if (submit) {
      submit.disabled = !variant || !variant.available;
      submit.textContent = !variant
        ? config.labels.unavailable
        : variant.available
          ? config.labels.addToCart
          : config.labels.soldOut;
    }

    if (!variant) return;

    if (price) {
      price.querySelector("[data-pin-price-value]").textContent = variant.price;
      price.classList.toggle("price--highlight", variant.onSale);
    }
    if (comparePrice) {
      comparePrice.hidden = !variant.onSale;
      comparePrice.querySelector("[data-pin-price-value]").textContent = variant.comparePrice;
    }
    if (details) details.href = config.productUrl + "?variant=" + variant.id;
  }

  function closeDialog() {
    if (openDialog && openDialog.open) openDialog.close();
  }

  function open(trigger) {
    var template = document.getElementById(trigger.getAttribute("data-promotion-pin"));
    if (!template) return;

    closeDialog();

    var fragment = document.importNode(template.content, true);
    var dialog = fragment.querySelector("dialog");
    if (!dialog) return;

    document.body.appendChild(dialog);
    openDialog = dialog;

    var config = readConfig(dialog);
    var form = dialog.querySelector("form");

    if (form) {
      form.addEventListener("change", function () {
        syncVariant(dialog, config);
      });
    }

    dialog.addEventListener("click", function (event) {
      if (event.target === dialog || event.target.closest("[data-pin-close]")) closeDialog();
    });

    dialog.addEventListener("close", function () {
      trigger.setAttribute("aria-expanded", "false");
      dialog.remove();
      if (openDialog === dialog) openDialog = null;
      if (trigger.isConnected) trigger.focus();
    });

    syncVariant(dialog, config);
    trigger.setAttribute("aria-expanded", "true");
    dialog.showModal();
  }

  document.addEventListener(
    "click",
    function (event) {
      var trigger = event.target.closest("[data-promotion-pin]");
      if (!trigger) return;
      // Captured at document level so a parent link or carousel never handles the click
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    },
    true
  );

  document.addEventListener("variant:added", closeDialog);
})();
